const STORAGE_KEY = "oko_session_state";

export const SESSION_PHASE = {
  TECH_CHECK: "tech_check",
  ACTIVE: "active",
};

export const saveSessionState = (partial) => {
  try {
    const existing = getSessionState() || {};
    const merged = { ...existing, ...partial };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch {
    // sessionStorage unavailable (e.g. private browsing quota exceeded)
  }
};

export const getSessionState = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearSessionState = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
